import { Box, Slider, styled } from '@mui/material';
import { theme } from '@side/pantry';
import { useContext, useEffect, useState } from 'react';
import Cropper, { type Area } from 'react-easy-crop';
import { getCroppedImage } from './helpers';
import { UploadImageModalContext } from './UploadImageModalContext';

const StyledSlider = styled(Slider)({
  height: 2,
  '& .MuiSlider-track': {
    height: 2,
  },
  '& .MuiSlider-rail': {
    height: 2,
  },
  '& .MuiSlider-thumb': {
    width: 12,
    height: 12,
    '&:before': {
      boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
    },
  },
});

export const Cropping = () => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [croppedArea, setCroppedArea] = useState<Area | null>(null);
  const [zoom, setZoom] = useState(1.5);

  const [state, dispatch] = useContext(UploadImageModalContext);

  const onCropComplete = (__: Area, croppedAreaPixels: Area) => {
    setCroppedArea(croppedAreaPixels);
  };

  useEffect(() => {
    const handleCrop = async () => {
      if (!croppedArea || !state?.base64Image) return;
      const croppedImg = await getCroppedImage(state.base64Image, croppedArea);
      if (croppedImg) {
        dispatch({ type: 'SET_BASE64_CROPPED_IMAGE', payload: croppedImg });
        dispatch({ type: 'ENABLE_CROP', payload: false });
      }
    };

    if (croppedArea && state?.base64Image) {
      handleCrop();
    }
  }, [croppedArea, state?.base64Image, dispatch]);

  if (!state?.base64Image && !state?.imageUrl) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: theme.spacing(3),
        marginTop: theme.spacing(3),
      }}
    >
      <Box>
        <Cropper
          image={state.base64Image ?? state.imageUrl ?? ''}
          crop={crop}
          zoom={zoom}
          showGrid={false}
          aspect={1}
          onCropComplete={onCropComplete}
          onCropChange={setCrop}
          onZoomChange={(z) => {
            dispatch({ type: 'USER_CROP_INTERACTION', payload: true });
            setZoom(z);
          }}
          onInteractionEnd={() =>
            dispatch({ type: 'USER_CROP_INTERACTION', payload: true })
          }
          cropShape="round"
          maxZoom={5.5}
          objectFit="contain"
          cropSize={{ width: 313, height: 313 }}
          style={{
            containerStyle: {
              position: 'relative',
              width: '332px',
              height: '332px',
            },
            cropAreaStyle: {
              border: '1px dashed rgba(255, 255, 255, 0.8)',
            },
          }}
        />
      </Box>
      <Box sx={{ width: '350px' }}>
        <StyledSlider
          value={zoom}
          aria-label="Zoom"
          min={1.5}
          step={0.1}
          max={5}
          onChange={(_e: Event, value: number | number[]) => {
            setZoom(typeof value === 'number' ? value : value[0]);
            dispatch({ type: 'USER_CROP_INTERACTION', payload: true });
          }}
        />
      </Box>
    </Box>
  );
};
